import { render, staticRenderFns } from "./unit-row.vue?vue&type=template&id=05564378&"
import script from "./unit-row.vue?vue&type=script&lang=ts&"
export * from "./unit-row.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/aef.slmndr.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05564378')) {
      api.createRecord('05564378', component.options)
    } else {
      api.reload('05564378', component.options)
    }
    module.hot.accept("./unit-row.vue?vue&type=template&id=05564378&", function () {
      api.rerender('05564378', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/estates/unit-row.vue"
export default component.exports